import { Button, Form, message, Input, Col, Row, Select, DatePicker, Modal } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import orderPaymentApis from 'api/orderPaymentApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';
import { orderTypes, orderStatus, FromPlans, VatRequests, VatExports, ExportTypes, ExportSources } from './helpers';
import { defaultDateFormat } from 'helpers/dateTimeHelper';
import moment from 'moment';
import { exportOrdersToCSV } from './helpers';
import { allow_manager_roles, current_account } from 'helpers/authorizeHelper';
import * as XLSX from 'xlsx';

export default function ListOrderPaymentsPage() {

  const [orderPayments, setOrderPayments] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();


  async function fetchOrderPayments(params={}) {
    setIsFetching(true);
    try {
      const res = await orderPaymentApis.listing(params);
      if (res.code === 200) {
        if(params['is_export'] == "true"){
          console.log(res.data)
          if(params['export_type'] == "vat"){
            exportVatToXlsx(res, params['vat_type'])
          }else{
            exportOrdersToCSV(res,params['export_type'])
          }
          // Reset export-related form fields after export
          searchForm.setFieldsValue({ 
            is_export: undefined,
            export_type: undefined
          });
        }else{
          updateOrderPayments(res)
        }
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  function updateOrderPayments(res) {
    setOrderPayments(res.data ?? []);
    setPaginate({page: res.page, limit: res.limit, total: res.total})
  }

  const defaultValues = {};

  function fetchDataByDefaultForm() {
    onFinishSearchForm(defaultValues);
  }

  useEffect(() => {
    fetchDataByDefaultForm()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const formValues = searchForm.getFieldsValue();
    const formattedValues = {
      ...formValues,
      start_date: formValues.start_date ? formValues.start_date.format('DD/MM/YYYY') : null,
      end_date: formValues.end_date ? formValues.end_date.format('DD/MM/YYYY') : null,
    };
    const args = Object.assign({}, params, formattedValues)
    await fetchOrderPayments(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchOrderPayments(params)
  };

  function exportVatToXlsx(jsonData, type) {
    const data = jsonData.data;
  
    // Helper function to format date from timestamp to dd/mm/yyyy
    const formatDate = (timestamp) => {
      const date = new Date(timestamp * 1000);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    if (type != 'company') {
      type = 'individual'
    }

    console.log("export type:", type)

    if (type === 'company') {
  
      // CSV headers
      var headers = [
        'MaHD',
        'NgayHoaDon',
        'MaKhacHang',
        'TenNguoiMua',
        'TenDonVi',
        'MaSoThue',
        'DiaChiKhachHang',
        'SoDienThoai',
        'Sobangke',
        'NgayBangke',
        'SOTKKHACH',
        'TENNHKHACH',
        'HinhThucThanhToan',
        'ThueSuat',
        'ThueXuatKhac',
        'MaHang',
        'TenHangHoa',
        'DVT',
        'SoLuong',
        'DonGia',
        'ThanhTien',
        'TienTe',
        'SoTT',
        'TinhChat',
        'Email',
        'Ghichu',
        'TyGia',
        'GiamTruHoaDon',
        'GiamTruHoaDonHangHoa',
        'TienGiamTru',
        'Tyle%ChietKhau',
        'TienChietKhau',
        'TienThue'
      ];
    
      // CSV rows
      var rows = data.map((item) => {
        const vatRequest = item.vat_requests[0] || {}; // Use the first VAT request if available
        return [
          item.id, // MaHD
          formatDate(item.created_at), // NgayHoaDon
          '', // MaKhacHang
          item.created_by?.name || item.prefilled_email, // TenNguoiMua
          vatRequest.company_name || '', // TenDonVi
          vatRequest.tax_code || '', // MaSoThue
          vatRequest.company_address || '', // DiaChiKhachHang
          vatRequest.phone_number || '', // SoDienThoai
          '', // Sobangke
          '', // NgayBangke
          '', // SOTKKHACH
          '', // TENNHKHACH
          'TM/CK', // HinhThucThanhToan
          -1, // ThueSuat
          '', // ThueXuatKhac
          '', // MaHang
          `Phần mềm AI - ${item.plan_id}(${item.plan_name}) - ${item.code}`, // TenHangHoa
          'Gói', // DVT
          1, // SoLuong
          item.amount ?? '', // DonGia
          item.amount ?? '', // ThanhTien
          'VND', // TienTe
          0, // SoTT
          1, // TinhChat
          vatRequest.recipient_email || item.prefilled_email, // Email
          '', // Ghichu
          '', // TyGia
          '', // GiamTruHoaDon
          '', // GiamTruHoaDonHangHoa
          '', // TienGiamTru
          '', // Tyle%ChietKhau
          '', // TienChietKhau
          '', // TienThue
        ];
      });
    } else {
      // CSV headers
      var headers = [
        'Số thứ tự hóa đơn',
        'Ngày hóa đơn',
        'Tên đơn vị mua hàng',
        'Mã số thuế',
        'Địa chỉ',
        'Người mua hàng',
        'Email',
        'Số điện thoại',
        'Căn cước công dân',
        'Hình thức thanh toán',
        'Tên hàng hóa/dịch vụ',
        'ĐVT',
        'Số lượng',
        'Đơn giá',
        'Thành tiền',
        'Thuế suất GTGT (%)',
        'Tiền thuế GTGT'
      ];
      var rows = data.map((item) => {
        const vatRequest = item.vat_requests && item.vat_requests.length > 0 ? item.vat_requests[0] : {};
        const isVatRequested = item.is_vat_requested || (vatRequest && Object.keys(vatRequest).length > 0);
        // Mã hoá đơn
        const maHD = item.id;
        // Mã số thuế
        const maSoThue = vatRequest.tax_code || "";
        // Ngày hóa đơn: ngày thanh toán thành công (ưu tiên paid_at, fallback created_at)
        const ngayHoaDon = item.paid_at ? formatDate(item.paid_at) : (item.created_at ? formatDate(item.created_at) : "");
        // Email
        const email = vatRequest.recipient_email || item.prefilled_email;
        // Tên đơn vị mua hàng
        const tenDonVi = vatRequest.company_name || "";
        // Địa chỉ
        const diaChi = vatRequest.company_address || "";
        // Người mua hàng
        const nguoiMuaHang = vatRequest.full_name || item.created_by?.name || "";
        // Số điện thoại
        const soDienThoai = vatRequest.phone_number || item.created_by?.phone_number || "";
        // Căn cước công dân
        const cccd = vatRequest.identity_card_number || ""
        // Hình thức thanh toán
        const hinhThucThanhToan = "Chuyển khoản";
        // Tên hàng hóa/dịch vụ
        const tenHangHoa = `Phần mềm AI White label - ${item.plan_id}(${item.plan_name}) - ${item.code}`;
        // ĐVT
        const dvt = "Gói";
        // Số lượng
        const soLuong = 1;
        // Đơn giá
        const donGia = item.amount;
        // Thành tiền
        const thanhTien = item.amount;
        // Thuế suất GTGT (%)
        const thueSuat = "KCT";
        // Tiền thuế GTGT
        const tienThue = 0;

        return [
          1,
          ngayHoaDon,
          tenDonVi,
          maSoThue,
          diaChi,
          nguoiMuaHang,
          email,
          soDienThoai,
          cccd,
          hinhThucThanhToan,
          tenHangHoa,
          dvt, // ĐVT
          soLuong, // Số lượng
          donGia, // Đơn giá
          thanhTien, // Thành tiền
          thueSuat, // Thuế suất GTGT (%)
          tienThue // Tiền thuế GTGT
        ];
      });
    }
  
    // Export as Excel (.xlsx) file using xlsx library.
    // Requires: import * as XLSX from 'xlsx';

    // Merge headers and data.
    const excelData = [headers, ...rows];

    // Create worksheet from data array and add to new workbook.
    const ws = XLSX.utils.aoa_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'HoaDon');

    // Format file name with current timestamp.
    const timeStamp = Math.floor(Date.now() / 1000);
    const fileName = `vat_${type}_${formatDate(timeStamp).replaceAll('/','_')}.xlsx`;

    // Save the Excel file and trigger browser download.
    XLSX.writeFile(wb, fileName);
  }


  const bottom = 'bottomRight';

  const [isRefundModalVisible, setIsRefundModalVisible] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [updateForm] = Form.useForm();
  const [isCompleteModalVisible, setIsCompleteModalVisible] = useState(false);
  const [refundForm] = Form.useForm();
  const [completeForm] = Form.useForm();

  const handleRefund = async () => {
    try {
      const values = { ...await refundForm.validateFields(), noted_by_id: current_account.id };
      const res = await orderPaymentApis.refundOrder(selectedOrderId, values);
      if (res.code === 200) {
        message.success('Order payment refunded successfully');
        setIsRefundModalVisible(false);
        refundForm.resetFields();
        
        // Get current form values and format dates properly
        const formValues = searchForm.getFieldsValue();
        const formattedValues = {
          ...formValues,
          start_date: formValues.start_date ? formValues.start_date.format('DD/MM/YYYY') : null,
          end_date: formValues.end_date ? formValues.end_date.format('DD/MM/YYYY') : null,
        };

        // Refresh the table with current pagination and properly formatted dates
        const params = {
          page: paginate.page,
          limit: paginate.limit,
          ...formattedValues
        };
        
        await fetchOrderPayments(params);
      }
    } catch (error) {
      message.error(error.message || 'Failed to refund order payment');
    }
  };

  const showRefundModal = (id) => {
    setSelectedOrderId(id);
    refundForm.resetFields();
    setIsRefundModalVisible(true);
  };

  const handleUpdate = async () => {
    try {
      const values = await updateForm.validateFields();
      const res = await orderPaymentApis.updateOrder(selectedOrderId, values);
      if (res.code === 200) {
        message.success('Order payment updated successfully');
        setIsUpdateModalVisible(false);
        
        // Get current form values and format dates properly
        const formValues = searchForm.getFieldsValue();
        const formattedValues = {
          ...formValues,
          start_date: formValues.start_date ? formValues.start_date.format('DD/MM/YYYY') : null,
          end_date: formValues.end_date ? formValues.end_date.format('DD/MM/YYYY') : null,
        };

        // Refresh the table with current pagination and properly formatted dates
        const params = {
          page: paginate.page,
          limit: paginate.limit,
          ...formattedValues
        };
        
        await fetchOrderPayments(params);
      }
    } catch (error) {
      message.error(error.message || 'Failed to update order payment');
    }
  };

  const showUpdateModal = (record) => {
    setSelectedOrderId(record.id);
    // Set initial values for the update form
    updateForm.setFieldsValue({
      type: record.type,
      discount_code: record.discount_code?.code,
      amount: record.amount,
      note: record.note,
    });
    setIsUpdateModalVisible(true);
  };

  const showCompleteModal = (id) => {
    setSelectedOrderId(id);
    completeForm.resetFields();
    setIsCompleteModalVisible(true);
  };

  const handleCompleteOrder = async () => {
    try {
      const values = { 
        ...await completeForm.validateFields(), 
        noted_by_id: current_account.id 
      };
      const res = await orderPaymentApis.completeOrder(selectedOrderId, values);
      if (res.code === 200) {
        message.success('Order payment completed successfully');
        setIsCompleteModalVisible(false);
        completeForm.resetFields();
        
        // Get current form values and format dates properly
        const formValues = searchForm.getFieldsValue();
        const formattedValues = {
          ...formValues,
          start_date: formValues.start_date ? formValues.start_date.format('DD/MM/YYYY') : null,
          end_date: formValues.end_date ? formValues.end_date.format('DD/MM/YYYY') : null,
        };

        // Refresh the table with current pagination and properly formatted dates
        const params = {
          page: paginate.page,
          limit: paginate.limit,
          ...formattedValues
        };
        
        await fetchOrderPayments(params);
      }
    } catch (error) {
      message.error(error.message || 'Failed to complete order payment');
    }
  };

  const columns = [
    {
      title: 'Detail',
      width: '30rem',
      render: (record) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div><strong>ID:</strong> <span>{record.id}</span></div>
          <div><strong>tenant_id:</strong> <span>{record.tenant_id}</span></div>
          <div>
            <strong>plan_id:</strong> <span>{record.plan_id}({record.plan_name})</span>
          </div>
          <div>
            <strong>prefilled_email:</strong> <span>{record.prefilled_email}</span>
          </div>
          <div>
            <strong>status:</strong> <span>{record.status}</span>
          </div>
          <div>
            <strong>type:</strong> <span>{record.type}</span>
          </div>
          <div>
            <strong>code:</strong> <span>{record.code}</span>
          </div>
          <div>
            <strong>discount_code:</strong>{" "}
            <span>
              {record.discount_code ? 
                `${record.discount_code.code} (${new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(record.discount_code.discount_value)})` : 
                'N/A'}
            </span>
          </div>
          <div>
            <strong>amount:</strong> <span>{record.amount}</span>
          </div>
          <div>
            <strong>quantity:</strong> <span>{record.quantity}</span>
          </div>
          <div>
            <strong>from_domain:</strong> <span>{record.from_domain}</span>
          </div>
          <div>
            <strong>referred_by_tenant_id:</strong> <span>{record.referred_by_tenant_id}</span>
          </div>
          <div>
            <strong>Created At:</strong> <span>{record.created_at ? fullDateTimeFormat(record.created_at) : 'N/A'}</span>
          </div>
          <div>
            <strong>Updated At:</strong> <span>{record.updated_at ? fullDateTimeFormat(record.updated_at) : 'N/A'}</span>
          </div>
        </div>
      )
    },
    {
      title: 'webhooks',
      width: '30rem',
      render: (record) => <span>{record.webhooks}</span>
    },
    {
      title: 'VAT Requests',
      width: '30rem',
      render: (record) => (
        <div>
          <div>
            <strong>Yêu cầu xuất VAT:</strong> <span>{record.is_vat_requested ? "Yes" : "No"}</span>
          </div>
           <div>
            <strong>Đã Export VAT:</strong> <span>{record.is_vat_exported ? "Yes" : "No"}</span>
          </div>
          {record.vat_requests && record.vat_requests.length > 0 ? (
            record.vat_requests.map((request) => (
              <div
                key={request.id}
                style={{
                  marginBottom: '1rem',
                  borderBottom: '1px solid #e8e8e8',
                  paddingBottom: '0.5rem',
                  background: '#fafafa',
                  borderRadius: '4px',
                  padding: '1rem'
                }}
              >
                <p>
                  <strong>Loại:</strong> {request.type || 'N/A'}
                </p>
                <p>
                  <strong>Tên Công Ty:</strong> {request.company_name || 'N/A'}
                </p>
                <p>
                  <strong>Mã số thuế:</strong> {request.tax_code || 'N/A'}
                </p>
                <p>
                  <strong>Địa chỉ công cty:</strong> {request.company_address || 'N/A'}
                </p>
                <p>
                  <strong>Email:</strong> {request.recipient_email || 'N/A'}
                </p>
                <p>
                  <strong>Họ Tên:</strong> {request.full_name || 'N/A'}
                </p>
                <p>
                  <strong>SDT:</strong> {request.phone_number || 'N/A'}
                </p>
                <p>
                  <strong>CCCD:</strong> {request.identity_card_number || 'N/A'}
                </p>
                <p>
                  <strong>Nguồn:</strong> {request.from_source || 'N/A'}
                </p>
                <p>
                  <strong>Note:</strong> {request.note || 'N/A'}
                </p>
                <p>
                  <strong>Created At:</strong> {request.created_at ? fullDateTimeFormat(request.created_at) : 'N/A'}
                </p>
                <p>
                  <strong>Updated At:</strong> {request.updated_at ? fullDateTimeFormat(request.updated_at) : 'N/A'}
                </p>
              </div>
            ))
          ) : (
            <p>No VAT requests</p>
          )}
        </div>
      )
    },
    {
      title: 'note',
      width: '30rem',
      render: (record) => <span>{record.note}</span>
    },
    ( allow_manager_roles(['super_admin']) ?
      {
        title: 'Tính Năng',
        width: '15rem',
        render: (record) => (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {record.status === 'completed' && (
              <Button 
                type="primary" 
                danger
                onClick={() => showRefundModal(record.id)}
                style={{ width: '100%' }}
              >
                Refund
              </Button>
            )}
            {record.status !== 'completed' && (
              <Button 
                type="primary"
                style={{ width: '100%', backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                onClick={() => showCompleteModal(record.id)}
              >
                Complete Order
              </Button>
            )}
            <Button
              type="primary"
              onClick={() => showUpdateModal(record)}
              style={{ width: '100%' }}
            >
              Update
            </Button>
          </div>
        )
      } : {})
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả OrderPayments"
        pageHeaderExtras={
          <>
            <Button
              style={{
                margin: '0 8px',
              }}
              type="primary"
              onClick={() => {
                window.Modal?.confirm
                  ? window.Modal.confirm({
                      title: 'Xác nhận xuất Orders với hoa hồng',
                      content: 'Bạn có chắc chắn muốn xuất dữ liệu Orders với hoa hồng không?',
                      onOk: () => {
                        searchForm.setFieldsValue({ 
                          is_export: 'true', 
                          export_type: 'orders_with_commission' 
                        });
                        searchForm.submit();
                      }
                    })
                  : (window.confirm('Bạn có chắc chắn muốn xuất dữ liệu Orders với hoa hồng không?') && (() => {
                      searchForm.setFieldsValue({ 
                        is_export: 'true', 
                        export_type: 'orders_with_commission' 
                      });
                      searchForm.submit();
                    })());
              }}
            >
              Export Orders với hoa hồng
            </Button>
            <Button
              style={{
                margin: '0 8px',
              }}
              type="primary"
              onClick={() => {
                window.Modal?.confirm
                  ? window.Modal.confirm({
                      title: 'Xác nhận xuất Orders',
                      content: 'Bạn có chắc chắn muốn xuất dữ liệu Orders không?',
                      onOk: () => {
                        searchForm.setFieldsValue({ 
                          is_export: 'true', 
                          export_type: 'orders' 
                        });
                        searchForm.submit();
                      }
                    })
                  : (window.confirm('Bạn có chắc chắn muốn xuất dữ liệu Orders không?') && (() => {
                      searchForm.setFieldsValue({ 
                        is_export: 'true', 
                        export_type: 'orders' 
                      });
                      searchForm.submit();
                    })());
              }}
            >
              Export Orders
            </Button>
            <Button
              style={{
                margin: '0 8px',
              }}
              type="primary"
              onClick={() => {
                window.Modal?.confirm
                  ? window.Modal.confirm({
                      title: 'Xác nhận xuất VAT',
                      content: 'Bạn có chắc chắn muốn xuất dữ liệu VAT không?',
                      onOk: () => {
                        searchForm.setFieldsValue({ 
                          is_export: 'true', 
                          export_type: 'vat' 
                        });
                        searchForm.submit();
                      }
                    })
                  : (window.confirm('Bạn có chắc chắn muốn xuất dữ liệu VAT không?') && (() => {
                      searchForm.setFieldsValue({ 
                        is_export: 'true', 
                        export_type: 'vat' 
                      });
                      searchForm.submit();
                    })());
              }}
            >
              Export VAT
            </Button>
          </>
        }
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          style={{marginBottom: "40px"}}
          onFinish={(values) => {
            // Format the start_date and end_date before submitting
            const formattedValues = {
              ...values,
              start_date: values.start_date ? values.start_date.format('DD/MM/YYYY') : null,
              end_date: values.end_date ? values.end_date.format('DD/MM/YYYY') : null,
            };
            console.log(formattedValues)
            // Call the server submission logic with the formatted values
            onFinishSearchForm(formattedValues);
          }}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name="start_date"
                label="Start Date"
                labelCol={{ span: 8 }}
              >
                <DatePicker 
                  placeholder="Select Start Date" 
                  style={{ width: '100%' }}
                  format={defaultDateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="end_date"
                label="End Date"
                labelCol={{ span: 8 }}
              >
                <DatePicker 
                  placeholder="Select End Date" 
                  style={{ width: '100%' }} 
                  format={defaultDateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='order_payment_id'
                label='order_payment_id'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm order payment id" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='tenant_id'
                label='tenant_id'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm theo tenant_id" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='code'
                label='code'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="Tìm theo code" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='prefilled_email'
                label='prefilled_email'
                labelCol={{ span: 8 }}
              >
                <Input placeholder="prefilled_email" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item 
                label="Loại"
                name="type"
                labelCol={{ span: 8 }}
              >
                <Select options={orderTypes} allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="Status"
                name="status"
                labelCol={{ span: 8 }}
              >
                <Select options={orderStatus} allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="From Plan"
                name="from_plan"
                labelCol={{ span: 8 }}
              >
                <Select options={FromPlans} allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="Yêu Cầu VAT"
                name="is_vat_requested"
                labelCol={{ span: 8 }}
              >
                <Select options={VatRequests} allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="Đã Exported VAT"
                name="is_vat_exported"
                labelCol={{ span: 8 }}
              >
                <Select options={VatExports} allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="VAT Export Type"
                name="vat_type"
                labelCol={{ span: 8 }}
              >
                <Select options={ExportTypes} placeholder="Chọn Export Type" allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item 
                label="VAT Export Source"
                name="vat_from_source"
                labelCol={{ span: 8 }}
              >
                <Select options={ExportSources} placeholder="Chọn Export Source" allowClear />
              </Form.Item>
            </Col>

          </Row>

          <Form.Item name="is_export" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="export_type" hidden>
            <Input />
          </Form.Item>

          <Row>
            <Col
              span={24}
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  fetchDataByDefaultForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={orderPayments}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
      <Modal
        title="Update Order Payment"
        open={isUpdateModalVisible}
        onOk={handleUpdate}
        onCancel={() => setIsUpdateModalVisible(false)}
        okText="Update"
        cancelText="Cancel"
        width={600}
      >
        {selectedOrderId && orderPayments.find(order => order.id === selectedOrderId) && (
          <div style={{ marginBottom: '24px' }}>
            <div style={{ padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px', marginBottom: '16px' }}>
              <h4 style={{ marginBottom: '12px' }}>Order Payment Details</h4>
              <div>
                <p><strong>Order ID:</strong> {orderPayments.find(order => order.id === selectedOrderId).id}</p>
                <p><strong>Plan:</strong> {orderPayments.find(order => order.id === selectedOrderId).plan_id} ({orderPayments.find(order => order.id === selectedOrderId).plan_name})</p>
                <p><strong>Email:</strong> {orderPayments.find(order => order.id === selectedOrderId).prefilled_email}</p>
                <p><strong>Status:</strong> {orderPayments.find(order => order.id === selectedOrderId).status}</p>
                <p><strong>Created At:</strong> {fullDateTimeFormat(orderPayments.find(order => order.id === selectedOrderId).created_at)}</p>
              </div>
            </div>
            
            <Form 
              form={updateForm}
              layout="vertical"
            >
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: 'Please select a type' }]}
              >
                <Select options={orderTypes} />
              </Form.Item>
              
              <Form.Item
                name="discount_code"
                label="Discount Code"
              >
                <Input placeholder="Enter discount code" />
              </Form.Item>
              
              <Form.Item
                name="amount"
                label="Amount"
                rules={[{ required: true, message: 'Please enter an amount' }]}
              >
                <Input type="number" placeholder="Enter amount" />
              </Form.Item>
              
              <Form.Item
                name="note"
                label="Note"
              >
                <Input.TextArea placeholder="Enter note" rows={4} />
              </Form.Item>
            </Form>
          </div>
        )}
      </Modal>
      <Modal
        title="Confirm Refund"
        open={isRefundModalVisible}
        onOk={handleRefund}
        onCancel={() => setIsRefundModalVisible(false)}
        okText="Refund"
        cancelText="Cancel"
        width={600}
      >
        {selectedOrderId && orderPayments.find(order => order.id === selectedOrderId) && (
          <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            <h4 style={{ marginBottom: '12px' }}>Order Payment Details</h4>
            <div>
              <p><strong>Order ID:</strong> {orderPayments.find(order => order.id === selectedOrderId).id}</p>
              <p><strong>Plan:</strong> {orderPayments.find(order => order.id === selectedOrderId).plan_id} ({orderPayments.find(order => order.id === selectedOrderId).plan_name})</p>
              <p><strong>Amount:</strong> {orderPayments.find(order => order.id === selectedOrderId).amount}</p>
              <p><strong>Email:</strong> {orderPayments.find(order => order.id === selectedOrderId).prefilled_email}</p>
              <p><strong>Type:</strong> {orderPayments.find(order => order.id === selectedOrderId).type}</p>
              <p><strong>Created At:</strong> {fullDateTimeFormat(orderPayments.find(order => order.id === selectedOrderId).created_at)}</p>
            </div>
          </div>
        )}
        
        <Form 
          form={refundForm}
          layout="vertical"
        >
          <Form.Item
            name="note"
            label="Note"
            rules={[{ required: true, message: 'Please enter a note' }]}
          >
            <Input.TextArea placeholder="Enter note for refund" rows={4} />
          </Form.Item>
        </Form>
        
        <p>Are you sure you want to refund this order payment?</p>
      </Modal>
      <Modal
        title="Confirm Complete Order"
        open={isCompleteModalVisible}
        onOk={handleCompleteOrder}
        onCancel={() => setIsCompleteModalVisible(false)}
        okText="Complete"
        cancelText="Cancel"
        width={600}
      >
        {selectedOrderId && orderPayments.find(order => order.id === selectedOrderId) && (
          <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            <h4 style={{ marginBottom: '12px' }}>Order Payment Details</h4>
            <div>
              <p><strong>Order ID:</strong> {orderPayments.find(order => order.id === selectedOrderId).id}</p>
              <p><strong>Plan:</strong> {orderPayments.find(order => order.id === selectedOrderId).plan_id} ({orderPayments.find(order => order.id === selectedOrderId).plan_name})</p>
              <p><strong>Amount:</strong> {orderPayments.find(order => order.id === selectedOrderId).amount}</p>
              <p><strong>Email:</strong> {orderPayments.find(order => order.id === selectedOrderId).prefilled_email}</p>
              <p><strong>Type:</strong> {orderPayments.find(order => order.id === selectedOrderId).type}</p>
              <p><strong>Current Status:</strong> {orderPayments.find(order => order.id === selectedOrderId).status}</p>
              <p><strong>Created At:</strong> {fullDateTimeFormat(orderPayments.find(order => order.id === selectedOrderId).created_at)}</p>
            </div>
          </div>
        )}
        
        <Form 
          form={completeForm}
          layout="vertical"
        > 
          <Form.Item
            name="note"
            label="Note"
            rules={[{ required: true, message: 'Please enter a note' }]}
          >
            <Input.TextArea placeholder="Enter note for completion" rows={4} />
          </Form.Item>
        </Form>
        
        <p>Are you sure you want to complete this order payment? This will change the status to 'completed'.</p>
      </Modal>
    </>
  );
}
